import React, { useCallback, useEffect, useMemo, useState } from 'react';
import AppLayout from '../../../../../component/appLayout';
import MembersNavbar from '../navBar';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import TasksDataV2 from '../../../../../component/tasks/taskDataV2';
import { captureException } from '../../../../../services/logService';
import { MY_TASKS_GROUP_FILTER_TYPE } from '../../../../../global/constants';
import { getUserWorkspacePreferenceData } from '../../../../../helpers/firebaseHelper';
import { isEmpty } from '../../../../../helpers/common';
import { Div } from '../overview/styles';
import { clearMemberTaskData } from '../../../../../actions/taskActions';
import { rootStore } from '../../../../../mobx/rootStore';
import { MobxMyTaskModelInterface } from '../../../../../interfaces/TaskInterface';
import { observer } from 'mobx-react-lite';

const MembersTaskDetails: React.FC = () => {
  // States
  const [loading, setLoading] = useState(false);

  //Mobx store variables
  const { workspaceStore, taskStore } = rootStore;
  const { currentWorkspace } = workspaceStore;
  const { myTasksFilter } = taskStore;

  // Other variables
  const dispatch = useDispatch();
  const params: { id: string } = useParams();

  // load initial data
  const loadData = useCallback(async () => {
    try {
      if (!isEmpty(currentWorkspace?.id)) {
        setLoading(true);
        // Get my task filter from user preference
        const userFilter = await getUserWorkspacePreferenceData('my_task_filter');
        taskStore.setMyTasksFilter(userFilter?.group_by ?? MY_TASKS_GROUP_FILTER_TYPE.DUE_DATE);
      }
    } catch (e) {
      captureException(e);
      console.log('error', e);
    } finally {
      setLoading(false);
    }
  }, [currentWorkspace?.id, taskStore]);

  useEffect(() => {
    loadData();
  }, [loadData]);
  useEffect(() => {
    return () => {
      dispatch(clearMemberTaskData());
    };
  }, [dispatch]);

  const membersTask = useMemo(() => {
    return (
      currentWorkspace?.users.find((user) => user.id === params?.id)?.filteredTasks ||
      ([] as MobxMyTaskModelInterface[])
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentWorkspace?.users, params?.id, myTasksFilter]);

  return (
    <>
      <AppLayout isPadding={true}>
        <MembersNavbar loadData={loadData} membersTask={membersTask} />
        <Div>
          <TasksDataV2 data={membersTask} loading={loading} loadData={loadData} isMember={true} memberId={params?.id} />
        </Div>
      </AppLayout>
    </>
  );
};

export default observer(MembersTaskDetails);
